import { Box } from "@mui/system";
import * as React from "react";
import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";
import Representment from "./modules/representment/representment";
import { WhiteHeader } from "./modules/shared/components/header/header";
import { Footer } from "./modules/shared/components/footer/footer";
import { ThemeProvider } from "@mui/material";
import { pagarmeTheme } from "theme/index";
import CssBaseline from "@mui/material/CssBaseline";

const RepresentmentContainer = styled(Container)`
  margin-top: 74px;
  flex-grow: 1;
`;

export default function App() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container sx={{ flex: 1 }}>
        <WhiteHeader />
        <RepresentmentContainer>
          <Representment />
        </RepresentmentContainer>
      </Container>
      <Footer />
    </Box>
  );
}

export const MainRoute = function () {
  return (
    <ThemeProvider theme={pagarmeTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
};
